/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unregisterAdvertiser} from '../api'

export const useMutationUnregisterAdvertiser = createReactQueryMutationHook('unregisterAdvertiser', unregisterAdvertiser)
